import React from 'react'
import { injectIntl } from 'react-intl'
import { withNotifications } from 'redux/enhancers'
import { Badge, Button, Menu, Dropdown } from 'antd'
import { BellOutlined } from '@ant-design/icons'
import Notification from './Notification'
import style from './style.module.scss'

const OVERFLOW_COUNT = 99

const Notifications = ({ notifications, intl: { formatMessage } }) => {
  const notificationsList = notifications.list.length > 0 ? (
    notifications.list.map(notification => (
      <Notification
        key={notification.id}
        notification={notification}
      />
    ))
  ) : (
    <div className={style.emptyPlaceholder}>
      {formatMessage({ id: 'notifications.empty' })}
    </div>
  )

  return (
    <Dropdown
      overlay={
        <Menu className={style.notifications}>
          {notificationsList}
        </Menu>
      }
      placement="bottomRight"
      trigger={["click"]}
      overflowCount={OVERFLOW_COUNT}
    >
      <Badge
        className={style.bellButton}
        count={notifications.unread}
      >
        <Button
          shape="circle"
          icon={<BellOutlined />}
          size="large"
        />
      </Badge>
    </Dropdown>
  )
}

export default injectIntl(withNotifications(Notifications))
